import { useContext } from "react";
import { AppContext } from "../context";
export function useApp() {
    var app = useContext(AppContext);
    if (!app) {
        throw new Error("Can not found app context");
    }
    return app;
}
